import React, { useState } from 'react';
import { EditPrintTemplateDialog, DocumentForm, ErpDataTableV2 } from '@/components/custom/erp';
import { BangKePhieuXuatTraNCCProvider, useBangKePhieuXuatTraNCCContext } from './context';
import { useDynamicSearch } from '@/hooks/use-dynamic-search';
import { invoiceReportColumns } from './cols-definition';
import SearchDialog from './components/SearchDialog';
import { useReport, useRows } from '@/hooks';
import { ActionBar } from './components';
import { QUERY_KEYS } from '@/constants';
import { useDialogState } from './hooks';

function BangKePhieuXuatTraNCCPageContent() {
  const { getReport, data, isLoading, currentPage, handlePageChange, totalItems, totalRow } = useReport({
    endpoint: QUERY_KEYS.BANG_KE_PHIEU_XUAT_TRA_LAI_NHA_CUNG_CAP,
    pageSize: 50
  });

  const {
    initialSearchDialogOpen,
    editPrintTemplateDialogOpen,
    showTable,
    searchParams,
    handleInitialSearch: handleInitialSearchHook,
    handleRefreshClick: handleRefreshClickHook,
    handleInitialSearchClose,
    handleSearchClick,
    handleEditPrintTemplateClick,
    handleClosePrintTemplateDialog,
    handleSavePrintTemplate,
    handleFixedColumnsClick,
    handleExportDataClick
  } = useDialogState();

  const { handleRowClick, selectedObj, setSelectedObj } = useRows();

  const {
    searchState,
    handleSearchChange,
    handleSearchPageChange,
    hasFilterParams,
    handleInitialSearch,
    handleRefreshClick,
    isSearching
  } = useDynamicSearch({
    onSearch: getReport,
    params: searchParams,
    onInitialSearch: handleInitialSearchHook,
    getColumns: () => invoiceReportColumns(() => {}),
    endpoint: QUERY_KEYS.BANG_KE_PHIEU_XUAT_TRA_LAI_NHA_CUNG_CAP,
    pageSize: 50
  });

  const [openDocumentForm, setOpenDocumentForm] = useState(false);
  const handleDocumentFormClick = (row: MuaHangRecord) => {
    setSelectedObj(row);
    setOpenDocumentForm(true);
  };

  const baseRows = hasFilterParams ? searchState.searchResults : data;
  const activeTotalRow = hasFilterParams ? searchState.totalRow : totalRow;
  const resolvedRows = [activeTotalRow, ...baseRows];

  const resolvedCurrentPage = hasFilterParams ? searchState.currentPage : currentPage;
  const resolvedTotalItems = hasFilterParams ? searchState.totalCount : totalItems;
  const resolvedHandlePageChange = hasFilterParams ? handleSearchPageChange : handlePageChange;

  const tables = [
    {
      name: '',
      rows: resolvedRows || [],
      columns: invoiceReportColumns(handleDocumentFormClick)
    }
  ];

  return (
    <div className='flex h-full min-h-screen w-full min-w-0 flex-col overflow-hidden'>
      {initialSearchDialogOpen && (
        <SearchDialog onClose={handleInitialSearchClose} onSearch={handleInitialSearch} initialValues={searchParams} />
      )}

      {openDocumentForm && selectedObj && (
        <DocumentForm
          document_uuid={selectedObj?.document_uuid}
          document_type={selectedObj?.document_type || 'PHIEU_XUAT_TRA_LAI_NHA_CUNG_CAP'}
          onClose={() => setOpenDocumentForm(false)}
        />
      )}

      <EditPrintTemplateDialog
        open={editPrintTemplateDialogOpen}
        onClose={handleClosePrintTemplateDialog}
        onSave={handleSavePrintTemplate}
      />

      {showTable && !openDocumentForm && (
        <>
          <ActionBar
            onSearchClick={handleSearchClick}
            onPrintClick={() => {}}
            onRefreshClick={handleRefreshClick}
            onFixedColumnsClick={handleFixedColumnsClick}
            onExportDataClick={handleExportDataClick}
            onEditPrintTemplateClick={handleEditPrintTemplateClick}
            fromDate={searchParams.ngay_ct1 || ''}
            toDate={searchParams.ngay_ct2 || ''}
          />

          <div className='min-h-0 min-w-0 flex-1 overflow-hidden'>
            <ErpDataTableV2
              tables={tables}
              onRowClick={handleRowClick}
              totalItems={resolvedTotalItems}
              pageSize={50}
              currentPage={resolvedCurrentPage}
              onPageChange={resolvedHandlePageChange}
              loading={isLoading || isSearching}
              onSearchChange={handleSearchChange}
            />
          </div>
        </>
      )}
    </div>
  );
}

export default function BangKePhieuXuatTraNCCPage() {
  return (
    <BangKePhieuXuatTraNCCProvider>
      <BangKePhieuXuatTraNCCPageContent />
    </BangKePhieuXuatTraNCCProvider>
  );
}
